module.exports = __webpack_public_path__ + "static/orcs_looking_for_wounded_elf-b4ee84d4c564a0cf98266f9d38d3aa81.png";